"use client";

import { cn } from "../../utils";
import { useCheckboxRootContext } from "./context";

export const CheckIcon = () => {
  const { size, disabled } = useCheckboxRootContext();

  return size === "sm" ? (
    <svg width="10" height="8" viewBox="0 0 10 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9 1L3.5 6.5L1 4"
        className={cn(disabled ? "stroke-neutral-90" : "stroke-white")}
        strokeWidth="1.6666"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ) : (
    <svg width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.6666 1.5L4.24998 7.91667L1.33331 5"
        className={cn(disabled ? "stroke-neutral-90" : "stroke-white")}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
